
import { useState } from "react";
import { ExistingSelectionMatchesExpression, RuleExpression } from "../../../api/models";
import RuleValueEditor from "../Values/rule_value";

export interface Props {
    expression: ExistingSelectionMatchesExpression;
    onUpdate: (a:ExistingSelectionMatchesExpression) => void;
}

const ExistingSelectionMatchesEditor = (props: Props) => {
    const [lhs, setLhs] = useState(props.expression.lhs);
    const [rhs, setRhs] = useState(props.expression.rhs);

    function onUpdateLhs(lhs: RuleExpression) {
        const expr = new ExistingSelectionMatchesExpression();
        expr.lhs = lhs;
        expr.rhs = rhs;
        props.onUpdate(expr);
        setLhs(lhs);
    }

    function onUpdateRhs(rhs: RuleExpression) {
        const expr = new ExistingSelectionMatchesExpression();
        expr.lhs = lhs;
        expr.rhs = rhs;
        props.onUpdate(expr);
        setRhs(rhs);
    }

    return (
        <div>
            <RuleValueEditor value={lhs} onUpdate={onUpdateLhs} />
            &nbsp; == &nbsp;
            <RuleValueEditor value={rhs} onUpdate={onUpdateRhs} />
        </div>
    );
};

export default ExistingSelectionMatchesEditor;
